class HasInfoPostOrUiAction {
  constructor(container, onInfoPostChosen, onUiActionChosen) {
    this.container = $(container);
    this.onInfoPostChosen = onInfoPostChosen;
    this.onUiActionChosen = onUiActionChosen;
    this.radioButtonGroup = this.container.find("input[type='radio']");
  }

  onThingsChosen = (value) => {
    if (value === "info_posts") {
      this.onInfoPostChosen();
    } else {
      this.onUiActionChosen();
    }
  };

  onRadioButtonClick = (event) => {
    this.onThingsChosen(event.target.value);
  };

  init = () => {
    const choice = this.container.find("input[type='radio']:checked");
    if (choice.length > 0) {
      const currentSelectedValue = choice.val();
      this.onThingsChosen(currentSelectedValue);
    }
  };

  attach = () => {
    this.radioButtonGroup.on("click", this.onRadioButtonClick);
    this.init();
  };

  detach = () => {
    this.radioButtonGroup.off("click", this.onRadioButtonClick);
  };
}

export default HasInfoPostOrUiAction;
